export default "__VITE_ASSET__01064a95__"